export default __webpack_public_path__ + "static/media/7magic.959ba534.png";